import React from 'react';
import { Link } from 'react-router-dom';

export class Error404Screen extends React.Component {
  render() {
    return (
      <div className="d-flex" style={{ height: "100vh" }}>
        <div className="big-error-w" style={{ maxWidth: "100%", margin: "auto" }}>
          <h1>
            404
          </h1>
          <h5>
            Page not Found
          </h5>
          <h4>
            Oops, Something went missing...
          </h4>

          <Link to="/" className="btn btn-primary mt-2">Go Back</Link>
        </div>
      </div>
    )
  }
};
